import { ChangeEvent, useState } from 'react';
import Input from '../reusable/Input';
import Checkbox from '../reusable/Checkbox';
import '../../styles/reusable/CollapsibleSection.css';
interface IncidentDetailsSectionProps {
 incidentId: string;
 requesterEmail: string;
 environmentImpact: string;
 publishToProd: boolean;
 onIncidentChange: (e: ChangeEvent<HTMLInputElement>) => void;
 onIncidentBlur: (e: ChangeEvent<HTMLInputElement>) => void;
 onEmailChange: (e: ChangeEvent<HTMLInputElement>) => void;
 onEnvironmentChange: (e: ChangeEvent<HTMLInputElement>) => void;
 onPublishChange: (e: ChangeEvent<HTMLInputElement>) => void;
 title?: string;
 defaultExpanded?: boolean;
}
/**
* Reusable Incident Details Section
* Same across all script execution pages
* Handles incident tracking and environment selection
*/
const IncidentDetailsSection = ({
 incidentId,
 requesterEmail,
 environmentImpact,
 publishToProd,
 onIncidentChange,
 onIncidentBlur,
 onEmailChange,
 onEnvironmentChange,
 onPublishChange,
 title = 'Incident Details',
 defaultExpanded = true,
}: IncidentDetailsSectionProps) => {
 const [isExpanded, setIsExpanded] = useState(defaultExpanded);
 return (
<div className="collapsible-section">
<div className="section-header" onClick={() => setIsExpanded(!isExpanded)}>
<h3>{title}</h3>
<span className="collapse-icon">{isExpanded ? '−' : '+'}</span>
</div>
     {isExpanded && (
<div className="section-content">
<div className="incident-grid">
<Input
         label="Incident/Request ID"
         name="incidentId"
         value={incidentId}
         onChange={onIncidentChange}
         onBlur={onIncidentBlur}
         placeholder="Enter Incident/Request ID"
         required
       />
<Input
         label="Requester Email Id"
         name="requesterEmail"
         value={requesterEmail}
         onChange={onEmailChange}
         placeholder="Auto-populated on tab out"
         required
         disabled
       />
<Input
         label="Environment Impact"
         name="environmentImpact"
         value={environmentImpact}
         onChange={onEnvironmentChange}
         disabled
         required
       />
<div className="publish-prod-wrapper">
<Checkbox
           label="Publish to Prod"
           name="publishToProd"
           checked={publishToProd}
           onChange={onPublishChange}
         />
</div>
</div>
</div>
     )}
</div>
 );
};
export default IncidentDetailsSection;